<div class="row">
	@for (tag of tags; track tag) {
		<ion-img src="/assets/item-view-tags/{{ tag.identifier }}.png"></ion-img>
	}
</div>
